module.exports = __webpack_public_path__ + "img/depthMap-sub230.4dde654d.png";